export default "__VITE_PUBLIC_ASSET__dd79406e__"